/* eslint-disable max-len */
export default {
    header: {
        title: 'Füllen Sie das folgende Formular aus.',
        subtitle: 'Unser Team wird sich umgehend mit Ihnen in Verbindung setzen, um die nächsten Schritte zu besprechen.',
        main: 'Wählen Sie den gewünschten Dienst'
    },
    list: {
        improve_title: 'Verbessern Sie die Sicherheit und/oder die DSGVO-Konformität der Anwendung',
        decrease_title: 'Reduzieren Sie das Risiko von Cyberangriffen in Ihrem Unternehmen (Datenmanagement)'
    },
    improve: [{
        title: 'Ich möchte die Sicherheit meiner Anwendungen in Bezug auf Folgendes überprüfen:',
        slug: 'improve-one',
        number: '1/4',
        option: [{
            text: 'Web',
            slug: 'web',
            icon: 'improve11'
        }, {
            text: 'Mobile',
            slug: 'mobile',
            icon: 'improve12'
        }, {
            text: 'Server',
            slug: 'server',
            icon: 'improve13'
        }]
    }, {
        title: 'Ich möchte die Sicherheitsüberprüfung:',
        slug: 'improve-two',
        number: '2/4',
        option: [{
            text: 'der bestehenden Anwendung',
            slug: 'running',
            icon: 'improve21'
        }, {
            text: 'des Quellcodes der Anwendung',
            slug: 'application',
            icon: 'improve22'
        }, {
            text: 'der Konfiguration des Produktionsservers',
            slug: 'production',
            icon: 'improve23'
        }]
    }, {
        title: 'Ich möchte sicher sein, dass die Anwendung DSGVO-konform ist:',
        slug: 'improve-three',
        number: '3/4',
        option: [{
            text: 'aus rechtlicher Sicht (Identifizierung personenbezogener Daten, Nutzungsbedingungen)',
            slug: 'legal',
            icon: 'improve31'
        }, {
            text: 'hinsichtlich der Systemarchitektur (Anpassung an die DSGVO-Vorschriften)',
            slug: 'system',
            icon: 'improve32de'
        }, {
            text: 'hinsichtlich der Cyber-Sicherheit (Sicherheit personenbezogener Daten)',
            slug: 'cybersecurity',
            icon: 'improve33'
        }]
    }, {
        title: 'Nach der Überprüfung benötige ich:',
        slug: 'improve-four',
        number: '4/4',
        option: [{
            text: 'Unterstützung in der Korrekturphase',
            slug: 'support',
            icon: 'common1'
        }, {
            text: 'eine erneute Überprüfung nach der vorgenommenen Korrektur',
            slug: 're-check',
            icon: 'common2'
        }, {
            text: 'eine kontinuierliche Überwachung der laufenden Anwendung und ihres Quellcodes',
            slug: 'monitor',
            icon: 'improve43'
        }]
    }],
    decrease: [{
        title: 'Die digitalen Ressourcen in meinem Unternehmen erfordern:',
        slug: 'decrease-one',
        number: '1/3',
        option: [{
            text: 'Aufnahme und Aufzeichnung',
            slug: 'recording',
            icon: 'decrease11'
        }, {
            text: 'Risikoberechnung',
            slug: 'calculation',
            icon: 'decrease12'
        }, {
            text: 'Risikomanagementpolitik/Sicherheitspolitik',
            slug: 'management',
            icon: 'decrease13'
        }]
    }, {
        title: 'Zum Schutz von:',
        slug: 'decrease-two',
        number: '2/3',
        option: [{
            text: 'persönlichen Daten',
            slug: 'personal',
            icon: 'decrease21'
        }, {
            text: 'Know-how, Vorschriften und Geschäftsgeheimnissen',
            slug: 'know-how',
            icon: 'decrease22'
        }, {
            text: 'Lohn- und Gehaltslisten',
            slug: 'payroll',
            icon: 'decrease23'
        }]
    }, {
        title: 'Nach der Überprüfung benötige ich:',
        slug: 'decrease-three',
        number: '3/3',
        option: [{
            text: 'Unterstützung in der Korrekturphase',
            slug: 'correction',
            icon: 'common1'
        }, {
            text: 'eine erneute Überprüfung nach der vorgenommenen Korrektur',
            slug: 'applying',
            icon: 'common2'
        }, {
            text: 'einen vorbereiteten Verifizierungsbericht',
            slug: 'verification',
            icon: 'decrease33'
        }]
    }],
    form: {
        name: 'Vor- und Nachname',
        mail: 'E-Mail',
        phone: 'Telefon',
        message: 'Nachricht',
        send: 'Senden',
        refresh: 'Neu Laden'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/estimation.js